import { Link } from "react-router-dom";

import { Brand } from "@/components/brand";

export function SiteFooter() {
  return (
    <footer className="border-t border-border/60 bg-background">
      <div className="container flex flex-col gap-4 py-10 text-sm text-muted-foreground md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-4">
          <Brand />
          <span className="hidden text-xs md:inline">Cloud-native Agent OS · Apache 2.0</span>
        </div>
        <div className="flex items-center gap-6 text-xs">
          <Link to="/login" className="transition-colors hover:text-foreground">
            Sign in
          </Link>
          <a href="#features" className="transition-colors hover:text-foreground">
            Features
          </a>
          <a
            href="https://github.com/knode-os/knode-os"
            target="_blank"
            rel="noreferrer"
            className="transition-colors hover:text-foreground"
          >
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
}
